export default "__VITE_ASSET__Bcsn0keU__"